module.exports = __webpack_public_path__ + "static/media/dentalpatient.d1833f94.png";